/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { changeType, updateData } from '../../state/actions/createData';

export default function Header() {
  const type = useSelector((state) => state.data.type);
  const dispatch = useDispatch();

  const popCN = type === 'POP' ? 'menu-item active' : 'menu-item';
  const coCN = type === 'CO' ? 'menu-item active' : 'menu-item';

  function onMenuClick(code) {
    dispatch(changeType(code));
    dispatch(updateData());
  }

  return (
    <section className="col-wrap">
      <img
        className="headerImg"
        src="images/PledgeStatusv3.png"
        width="1260"
        height="531"
        alt="Country CO2"
      />
      <p>
        Click on a space in the graphic below to see what year each country has
        pledged to achieve net zero. Pledges fall into four categories:
      </p>
      <div className="key-list">
        {/* <div className="top-key">
          <div className="ind1" />
          <div className="ind-text">Achieved (self-declared)</div>
        </div> */}
        <div className="top-key">
          <div className="ind2" />
          <div className="ind-text">In law</div>
        </div>
        <div className="top-key">
          <div className="ind3" />
          <div className="ind-text">In policy document</div>
        </div>
        <div className="top-key">
          <div className="ind4" />
          <div className="ind-text">Declaration / pledge</div>
        </div>
        <div className="top-key">
          <div className="ind5" />
          <div className="ind-text">Proposed / in discussion</div>
        </div>
      </div>

      <p>
        Toggle to see countries displayed by population size or CO2 emissions
        and scroll down to see the full list.
      </p>
      <div className="fragment">
        <div className="menu">
          <div
            className={popCN}
            role="menuitem"
            tabIndex="0"
            onClick={() => {
              onMenuClick('POP');
            }}
          >
            POPULATION
          </div>
          <div
            className={coCN}
            role="menuitem"
            tabIndex="0"
            onClick={() => {
              onMenuClick('CO');
            }}
          >
            CO2 EMISSIONS
          </div>
        </div>
      </div>
    </section>
  );
}
